module.exports = __webpack_public_path__ + "static/scale-model-of-memorial-park-in-jacksonville-florida-f8f5ad13fe6e5fde5087cdf67f88220c.png";